import { render } from "./Docks.vue?vue&type=template&id=5af04f26"
import script from "./Docks.vue?vue&type=script&lang=js"
export * from "./Docks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__